import {
	CHAT_LIST_GET_LIST,
	CHAT_LIST_GET_LIST_SUCCESS,
	CHAT_LIST_GET_LIST_ERROR,
	CHAT_LIST_GET_LIST_WITH_FILTER,
	CHAT_GET,
	CHAT_GET_SUCCESS,
	CHAT_GET_ERROR
} from '../actions';

const INIT_STATE = {
	allchats: null,
	chats: null,
	loading: false,
	currentUser: null,
	selectedchat: null,
	chatdetailloading: false,
	loadchats: null
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case CHAT_LIST_GET_LIST:
			return { ...state, loading: false };

		case CHAT_LIST_GET_LIST_SUCCESS:
			// console.log(action.payload)       ; 
			return { ...state, loading: true, allchats: action.payload.chats, chats: action.payload.chats, currentUser: action.payload.currentUser, loadchats: action.payload.loadchats };

		case CHAT_LIST_GET_LIST_ERROR:
			return { ...state, loading: true, error: action.payload };
		default: return { ...state };

		case CHAT_GET:
			return { ...state, chatdetailloading: false };

		case CHAT_GET_SUCCESS:
			return { ...state, chatdetailloading: true, selectedchat: action.payload.chat };

		case CHAT_GET_ERROR:
			return { ...state, chatdetailloading: true, error: action.payload };


		case CHAT_LIST_GET_LIST_WITH_FILTER:
			console.log(action.payload);
			if (action.payload.startDate === '' || action.payload.endDate === '') {
				return { ...state, loading: true, chats: state.allchats, filter: null };
			} else {

				const filteredItems = state.allchats.filter((item) =>
					//console.log(new Date(item["chatDateTime"]).getTime())
					new Date(item["chatDateTime"]).getTime() >= new Date(action.payload.startDate).getTime() &&
					new Date(item["chatDateTime"]).getTime() <= new Date(action.payload.endDate).getTime()
					&& (item["hotel"] === action.payload.hotel || "-1" === action.payload.hotel)
				);
				//item[action.payload.column] === action.payload.value);
				return {
					...state, loading: true, chats: filteredItems, filter: {
						startDate: action.payload.startDate,
						endDate: action.payload.endDate
					}
				}
			}
	}
}
